var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerPinkSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 57,
    viewBox: "0 0 51 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2514_1282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2221 17.9247C37.7608 -5.14156 12.3012 -5.14156 21.8399 17.9247C12.3012 -5.14156 -5.73556 12.8952 17.3307 22.4339C-5.73556 12.8952 -5.73556 38.3548 17.3307 28.8161C-5.73556 38.3895 12.2665 56.3916 21.8399 33.3253C12.2665 56.3916 37.7608 56.3916 28.2221 33.3253C37.7955 56.3916 55.7976 38.3895 32.7313 28.8161C55.7976 38.3895 55.7976 12.8952 32.7313 22.4339C55.7976 12.8952 37.7608 -5.14156 28.2221 17.9247Z",
    fill: "#EA86AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 28.123L17.6182 29.5088C11.9461 31.863 8.91816 34.6878 7.62169 37.1523C6.32958 39.6086 6.75492 41.6594 7.87576 42.7802C8.99661 43.9011 11.0474 44.3264 13.5037 43.0343C15.9682 41.7379 18.793 38.71 21.1472 33.0378L21.8399 33.3253L22.5326 33.6128C20.1784 39.2849 20.0314 43.4206 20.856 46.0778C21.6778 48.7256 23.4296 49.875 25.018 49.875C26.6067 49.875 28.3609 48.7252 29.1868 46.0768C30.0155 43.4194 29.8746 39.2838 27.5291 33.6119L28.9148 33.0378C31.269 38.71 34.0938 41.7379 36.5583 43.0343C39.0146 44.3264 41.0654 43.9011 42.1862 42.7802C43.3071 41.6594 43.7324 39.6086 42.4403 37.1523C41.1439 34.6878 38.116 31.863 32.4438 29.5088L32.7313 28.8161L33.0188 28.1234C38.6909 30.4776 42.8266 30.6246 45.4838 29.8C48.1316 28.9783 49.281 27.2264 49.281 25.638C49.281 24.0493 48.1312 22.2951 45.4828 21.4692C42.8254 20.6405 38.6898 20.7814 33.0179 23.127L32.7313 22.4339L32.4447 21.7408C38.1166 19.3953 41.1417 16.5749 42.4353 14.1127C43.7242 11.6592 43.2971 9.60668 42.1732 8.48277C41.0493 7.35886 38.9969 6.93177 36.5433 8.22075C34.0811 9.51429 31.2607 12.5394 28.9152 18.2113L28.2221 17.9247L27.5291 17.6381C29.8746 11.966 30.0177 7.83021 29.1915 5.17259C28.368 2.524 26.6169 1.375 25.031 1.375C23.4451 1.375 21.694 2.524 20.8705 5.17259C20.0443 7.83021 20.1874 11.966 22.533 17.6381L21.8399 17.9247L21.1468 18.2113C18.8013 12.5394 15.9809 9.51429 13.5187 8.22075C11.0652 6.93177 9.01268 7.35886 7.88877 8.48277C6.76486 9.60668 6.33778 11.6592 7.62676 14.1127C8.9203 16.5749 11.9454 19.3953 17.6173 21.7408L17.3307 22.4339L17.0441 23.127C11.372 20.7814 7.23622 20.6383 4.57859 21.4645C1.93 22.288 0.781005 24.0391 0.781005 25.625C0.781005 27.2109 1.93 28.962 4.57859 29.7855C7.23606 30.6117 11.3715 30.4686 17.0431 28.1235L17.0441 28.123ZM17.0441 28.123C17.0438 28.1232 17.0435 28.1233 17.0432 28.1234L17.0441 28.123Z",
    stroke: "#1C1616",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2514_1282",
    x: 0.0310059,
    y: 0.625,
    width: 50,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2514_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2514_1282",
    result: "effect2_dropShadow_2514_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2514_1282",
    result: "effect3_dropShadow_2514_1282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2514_1282",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerPinkSm);
export default __webpack_public_path__ + "static/media/flower-pink-sm.07109264.svg";
export { ForwardRef as ReactComponent };